import { iframeApi } from '..';

interface IData {
  type: 'huddle01-iframe-from-parent';
  method: keyof typeof iframeApi | 'theme';
  eventData?: any; // TODO: fix types
}

export const sendDataToIframe = (eventData: IData) => {
  const huddleIframe: HTMLIFrameElement = document.getElementById(
    'huddle01-iframe',
  ) as HTMLIFrameElement;
  if (huddleIframe?.contentWindow)
    huddleIframe.contentWindow.postMessage(eventData || null, '*');
  else console.log('huddleIframe is null');
};

export const zodErrHandler =
  <T extends any[], U>(
    func: (...args: T) => PromiseLike<U>,
  ): ((...args: T) => Promise<U>) =>
  async (...args) => {
    try {
      return await func(...args);
    } catch (err) {
      console.log(func.name + ' caused an error', err);
      throw err;
    }
  };
